import { useNode } from '@craftjs/core';
import React, { useCallback } from 'react';
import { Container } from '@descope/page-editor-components';
import { EditorContainerSettings } from './EditorContainerSettings';

const EditorContainer = (props: React.ComponentProps<typeof Container>) => {
	const {
		connectors: { connect, drag }
	} = useNode((state) => ({
		hasSelectedNode: state.events.selected,
		hasDraggedNode: state.events.dragged
	}));

	const refCb = useCallback(
		(ref: HTMLDivElement) => connect(drag(ref)),
		[connect, drag]
	);

	return (
		<Container
			ref={refCb}
			{...props}
			// in case there is no content and no padding, the container becomes invisible in the editor
			// this sets the min height so it won't disappear,
			// it will take effect in editor only, rendered pages will not have this style
			style={{ minHeight: 5 }}
		/>
	);
};

EditorContainer.craft = {
	name: 'Container',
	props: {
		paddingX: '4',
		paddingY: '8',
		align: 'start',
		background: '#ffffff00',
		width: '100',
		justify: 'center',
		direction: 'row',
		spaceBetween: '4',
		'data-editor-type': 'container'
	},
	related: {
		settings: EditorContainerSettings
	}
};

export { EditorContainer };
